'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SearchConstants = {
    LINK_TARGET: '',
    ENABLE_ORDER_BY: 'false',
    REFINEMENT_STYLE: 'link',
    RESULTS_URL: '/zoek/Paginas/zoeken.aspx'
};

exports.default = SearchConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/search/search.constants.js
// module id = 823
// module chunks = 0